var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.isDropDown ? '' : 'nav-item'},[_c('router-link',{class:_vm.isDropDown ? 'dropdown-item' : '',attrs:{"to":_vm.menuItem.link}},[(_vm.menuItem.icon)?[_c('span',{staticClass:"fontIcon"},[_c('font-awesome-icon',{attrs:{"icon":_vm.menuItem.icon}})],1)]:_vm._e(),_vm._v("\n    "+_vm._s(_vm.menuItem.label)+"\n  ")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e0e5db0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menus/SideMenuNode.vue
// module id = null
// module chunks = 